import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const IsoIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <defs>
   <mask id="mask" x="0" y="0" width="20" height="20" maskUnits="userSpaceOnUse">
    <g id="custom">
     <rect id="bg" y="0" width="20" height="20" fill="#fff" />
    </g>
   </mask>
   <clipPath id="clippath">
    <rect width="20" height="20" fill="none" />
   </clipPath>
  </defs>
  <g mask="url(#mask)">
   <g id="g177">
    <g id="g179">
     <path
      id="path181"
      d="M3.67,6.91v6.13"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
     />
    </g>
    <g id="g183">
     <g clipPath="url(#clippath)">
      <g id="g185">
       <g id="g191">
        <path
         id="path193"
         d="M19.22,15.12c0,1.29-1.05,2.34-2.34,2.34H3.12c-1.29,0-2.34-1.05-2.34-2.34V4.92c0-1.29,1.05-2.34,2.34-2.34h13.75c1.29,0,2.34,1.05,2.34,2.34v6.25"
         fill="none"
         stroke="currentColor"
         strokeLinecap="round"
         strokeLinejoin="round"
        />
       </g>
       <g id="g195">
        <path
         id="path197"
         d="M16.52,8.95c0-1.12-.91-2.03-2.03-2.03s-2.03.91-2.03,2.03v2.03c0,1.12.91,2.03,2.03,2.03s2.03-.91,2.03-2.03v-2.03Z"
         fill="none"
         stroke="currentColor"
         strokeLinecap="round"
         strokeLinejoin="round"
        />
       </g>
       <g id="g199">
        <path
         id="path201"
         d="M9.73,8.05c0-.65-.54-1.14-1.19-1.14h-.68c-.78,0-1.42.61-1.42,1.39v.11c0,.79.63,1.43,1.42,1.43h.72c.78,0,1.42.63,1.42,1.42v.37c0,.79-.64,1.38-1.42,1.38h-1.16c-.64,0-1.17-.49-1.17-1.13"
         fill="none"
         stroke="currentColor"
         strokeLinecap="round"
         strokeLinejoin="round"
        />
       </g>
      </g>
     </g>
    </g>
   </g>
  </g>
 </svg>,
 "Iso"
);
